export default __webpack_public_path__ + "static/media/t1.47e87410.jpg";